export default __webpack_public_path__ + "static/media/portfolio-tablet-main.b5d3041a.webp";